import React from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type IconLayer = {
    icon: IconDefinition;
    className?: string;
    size?: "xs" | "sm" | "lg" | "xl" | "2x" | "3x" | "5x" | "7x" | "10x";
    position?:
        | "center"
        | "top-right"
        | "top-left"
        | "bottom-right"
        | "bottom-left";
};

type Props = {
    baseIcon: IconDefinition;
    baseClassName?: string;
    baseSize?: IconLayer["size"];
    overlays?: IconLayer[];
    className?: string;
};

const positionClasses: Record<string, string> = {
    center: "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
    "top-right": "top-0 right-0 translate-x-1/3 -translate-y-1/3",
    "top-left": "top-0 left-0 -translate-x-1/3 -translate-y-1/3",
    "bottom-right": "bottom-0 right-0 translate-x-1/3 translate-y-1/3",
    "bottom-left": "bottom-0 left-0 -translate-x-1/3 translate-y-1/3",
};

export const IconStack = ({
    baseIcon,
    baseClassName = "",
    baseSize = "2x",
    overlays = [],
    className = "",
}: Props) => {
    return (
        <div className={`relative inline-block ${className}`}>
            <FontAwesomeIcon
                icon={baseIcon}
                size={baseSize}
                className={baseClassName}
            />

            {overlays.map((layer, idx) => (
                <FontAwesomeIcon
                    key={idx}
                    icon={layer.icon}
                    size={layer.size}
                    className={`absolute ${positionClasses[layer.position ?? "center"]} ${layer.className ?? ""}`}
                />
            ))}
        </div>
    );
};
